export default "__VITE_ASSET__Da49XZYu__"